import {COMP_FIELDS, CompFieldValue} from '@/constants/comp';
import {AccountPacInvestmentInstructions} from '@/types/client-info';
import {FundKeyFields} from './comp-to-investment-mappings';

export const COMP_TO_PAC_MAPPINGS: {
  compKeyField: CompFieldValue;
  investmentType: keyof AccountPacInvestmentInstructions;
  getKey: (item: FundKeyFields) => string;
}[] = [
  {
    compKeyField: COMP_FIELDS.COMP46_pacBenevaInvestmentAccountFundCode,
    investmentType: 'benevaInvestmentAccounts',
    getKey: item => item.fundCode,
  },
  {
    compKeyField: COMP_FIELDS.COMP50_pacDailyInterestAccountFundCode,
    investmentType: 'dailyInterestAccounts',
    getKey: item => item.fundCode,
  },
  {
    compKeyField: COMP_FIELDS.COMP53_pacHighYieldAccountFundCode,
    investmentType: 'highYieldAccounts',
    getKey: item => item.fundCode,
  },
  {
    compKeyField: COMP_FIELDS.COMP56_pacBenevaGuaranteedInvestmentFundFundCode,
    investmentType: 'benevaGuaranteedInvestmentFunds',
    getKey: item => item.fundCode,
  },
];
